module.exports = __webpack_public_path__ + "static/media/DBHeaventNow.4de705ae.woff2";